module.exports = __webpack_public_path__ + "img/6_95.f029b1c6.png";